import React from 'react'
import { ButtonBlock } from '@core/Components/Buttons/ButtonBlock'
import { SameRaceMultiQuickbetStyled } from './SameRaceMultiQuickbet.styles'

export interface SameRaceMultiQuickbetProps {
  isValid: boolean
  handleQuickbetSelected(): void
}

export const SameRaceMultiQuickbet = ({
  isValid,
  handleQuickbetSelected,
}: SameRaceMultiQuickbetProps) => {
  return (
    <SameRaceMultiQuickbetStyled>
      <ButtonBlock
        disabled={!isValid}
        onClick={handleQuickbetSelected}
        data-tid-place-single-btn='bet-forward-buttons'
      >
        Quickbet
      </ButtonBlock>
    </SameRaceMultiQuickbetStyled>
  )
}
